<template>
  <vs-row>
    <form>
      <vs-tabs alignment="fixed">
        <vs-tab label="Étel adatok">
          <vs-row vs-type="flex">
            <vs-col vs-lg="6" vs-sm="12">
              <vs-input label="Étel név (kötelező)" v-model="selected.ItemName"></vs-input>
              <vs-input type="number" label="Étel ár (kötelező)" v-model="selected.ItemPrice"></vs-input>
              <vs-textarea label="Étlap leírás" v-model="selected.ItemDescription"></vs-textarea>
              <vs-checkbox v-model="childItem">Alcikk</vs-checkbox>
              <vs-checkbox v-model="sticky">Rögzített</vs-checkbox>
              <transition name="fade">
                <vs-row v-if="childItem">
                  <vs-select autocomplete placeholder="Válasszon főcikket" label="Főcikk"
                             v-model="selected.ParentId">
                    <vs-select-item :key="index" :value="item.ItemId" :text="item.ItemName"
                                    v-for="(item,index) in itemList"/>
                  </vs-select>
                </vs-row>
              </transition>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="12">
              <label for="fileUpload_new">
                <input id="fileUpload_new" type="file" style="visibility: hidden;" accept=".jpg,.png"
                       @input="setImage()">
                <img class="itemImage" alt="Item Image" :src="imgSrc"/>
              </label>
            </vs-col>
          </vs-row>
        </vs-tab>
        <vs-tab label="Címkék">
          <vs-select autocomplete multiple placeholder="Válasszon címkéket" label="Címkék"
                     v-model="selected.ItemLabels">
            <vs-select-item :key="index" :value="item.Id" :text="item.LabelName"
                            v-for="(item,index) in labelList"/>
          </vs-select>
        </vs-tab>
        <vs-tab label="Extrák">
          <vs-row>
            <vs-select autocomplete multiple placeholder="Válasszon extrákat" label="Extrák"
                       v-model="selected.ItemAddons">
              <vs-select-item :key="index" :value="item.Id" :text="item.AddonName"
                              v-for="(item,index) in addonList"/>
            </vs-select>
          </vs-row>
        </vs-tab>
        <vs-tab label="Kategória & csoport">
          <vs-row>
            <vs-select autocomplete placeholder="Válasszon kategóriát" label="Kategória"
                       v-model="selected.ItemMenu">
              <vs-select-item :key="index" :value="item.Id" :text="item.MenuName"
                              v-for="(item,index) in menuList"/>
            </vs-select>
          </vs-row>
          <vs-row>
            <vs-select autocomplete placeholder="Válasszon csoportot" label="Csoport"
                       v-model="selected.ItemCategory">
              <vs-select-item :key="index" :value="item.Id" :text="item.CategoryName"
                              v-for="(item,index) in categoryList"/>
            </vs-select>
          </vs-row>
        </vs-tab>
      </vs-tabs>
      <vs-row class="justify-content-center saveButton">
        <vs-button @click="save()" color="success" type="gradient" :disabled="isNotSaveable()">Mentés
        </vs-button>
      </vs-row>
    </form>
  </vs-row>
</template>

<script>
import {axiosInstance} from "@/main";

export default {
  name: "new_item",
  props: ['selected', 'categoryList', 'labelList', 'addonList', 'menuList', 'dailyItem', 'itemList'],
  data() {
    return {
      imgSrc: this.$root.imagePath + 'default.jpg',
      childItem: false,
      sticky: false
    }
  },
  methods: {
    save() {
      let self = this;
      let url = self.dailyItem ? 'admin/dailyMenuItemController.php?action=new' : 'admin/itemController.php?action=new';
      let input = document.getElementById("fileUpload_new");
      let form = new FormData();

      if (input !== null && input.files !== null && input.files.length !== 0)
        form.append('itemImage', input.files[0]);
      form.append('itemData', JSON.stringify(self.selected));

      axiosInstance({
        method: 'post',
        url: url,
        data: form,
        headers: {'Content-Type': 'multipart/form-data'},
      }).then((resp) => {
        self.$vs.notify({
          title: 'Rendszerüzenet',
          position: 'top-right',
          text: resp.data.status === 'OK' ? 'Sikeres mentés.' : 'Sikertelen mentés. ' + resp.data.message,
          color: resp.data.status === 'OK' ? 'success' : 'danger',
          icon: resp.data.status === 'OK' ? 'check_box' : 'error'
        });
        self.$parent.$emit('closemodal');
      })
          .catch((err) => {
            if (err.response.status === 401)
              self.$root.exterminatus();
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    setImage() {
      let self = this;
      let input = document.getElementById("fileUpload_new");
      if (input.files && input.files[input.files.length - 1]) {
        let reader = new FileReader();
        if ((input.files[input.files.length - 1].size / 1024 / 1024) > 2) {
          self.$vs.dialog({
            color: 'danger',
            title: 'Hiba',
            text: 'A fájl mérete túl nagy. A maximum megengedett fájlméret 2 megabyte.',
            buttonAccept: 'Rendben'
          });
          input.value = '';
          return;
        }
        reader.readAsDataURL(input.files[input.files.length - 1]);
        reader.onload = function (e) {
          self.imgSrc = e.target.result
        };
      }
    },
    isNotSaveable() {
      return !this.selected.ItemName || !Number.isInteger(parseInt(this.selected.ItemPrice));
    }
  }
}
</script>

<style scoped>
.con-vs-checkbox {
  margin-top: 15px;
}

.vs-input, .con-select {
  margin-top: 5px;
  margin-bottom: 5px;
  width: 100%;
}

.vs-textarea-primary {
  margin-top: 15px;
}

form {
  width: 100%;
}

label {
  text-align: center;
}

.itemImage {
  border: 1px solid #ccc;
  width: 270px;
  height: 190px;
  overflow: hidden;
  border-radius: 10px;
  object-fit: cover;
  cursor: pointer;
  background-size: cover;
}
</style>